import { render, staticRenderFns } from "./SizeGuide.vue?vue&type=template&id=a4cc7322&scoped=true&"
import script from "./SizeGuide.vue?vue&type=script&lang=js&"
export * from "./SizeGuide.vue?vue&type=script&lang=js&"
import style0 from "./SizeGuide.vue?vue&type=style&index=0&id=a4cc7322&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cc7322",
  null
  
)

export default component.exports